import logo from './logo.svg';
import './App.css';
import Navbar from './Components/Navbar';
import Hero from './Components/Hero';
import WhyChooseUs from './Components/WhyChooseUs';
import Packages from './Components/Packages';
import Footer from './Components/Footer';
import Contact from './Components/Contact';
import Blog from './Components/Blog';
import Comparison from './Components/Comparison';
import Coverage from './Components/Coverage';

function App() {
  return (
    <div>
      <Navbar />
      {/* Other content can go here */}
      <div className='full-width-block'>
        <p>
          <b>Where Business Moves at the Speed of Fibre</b>
        </p>
      </div>
      <Hero />
      <Coverage />
      <Packages />
      <Comparison />
      <WhyChooseUs />
      <Blog />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
